import {BaseState} from "../BaseState";

export enum AdaptiveType {
  all = "All",
  desktop = "desktop",
  mobile = "mobile"
}

export interface CachedUrl {
  readonly url: string;
  readonly adaptiveType: AdaptiveType;
}

export interface QueryResult {
  readonly query: {
    readonly like?: string;
    readonly regex?: string;
    readonly adaptiveType?: AdaptiveType;
    readonly limit?: number;
    readonly offset?: number;
  };
  readonly urls: Array<CachedUrl>;
  readonly count: number;
}

export default interface UrlsState extends BaseState {
  readonly result: QueryResult | null;
}
